<template>
    <div class="psReportsDetail">
      <div class="psReportsDetailUpperBar column">
          <div class="row rowMenu">
              <ps-back-button v-show="isMobile == true"></ps-back-button>
              <h1 v-if="isMobile == true && reportTitle" class="reportTitle">{{ reportTitle }}</h1>
          </div>
          <div class="row">
              <ps-back-button v-if="isMobile == false"></ps-back-button>
              <h1 v-if="isMobile == false && reportTitle" class="reportTitle">{{ reportTitle }}</h1>
              <ps-avatar class="avatar"></ps-avatar>
          </div>
      </div>

      <div style="width: 100%; margin-top: 0">
        <router-view></router-view>
      </div>
    </div>
</template>

<script>
import PsAvatar from "@/components/layout/PsAvatar.vue";
import PsBackButton from "@/components/PsBackButton.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  name: "PsReportsDetail",
  props: {
    site: Object,
    icon: String,
  },
  components: { PsAvatar, PsBackButton },
  computed: {
    ...mapState("routes", ["routeSite"]),
    ...mapState(["user", "isMobile"]),
    ...mapGetters(["isAdmin"]),
    reportTitle() {
      return this.$route.meta.reportTitle || "";
    },
  },
  methods: {},
};
</script>

<style scoped>
.psReportsDetail {
  height: 100%;
  width: 100%;
}
.psReportsDetailUpperBar {
  height: 60px;
  display: flex;
  margin-top: 50px;
}
.psReportsDetailUpperBar > .row {
  margin-bottom: 0;
  padding-left: 10px;
  align-items: center;
}
.reportTitle {
  color: #3e8091;
  font-size: 1.6rem;
  line-height: 40px;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rowDate,
.showPdf {
  margin-left: 10px;
  color: #555;
  cursor: pointer;
  padding: 5px 14px;
  border: 1px solid #999;
  border-radius: 4px;
  box-shadow: 1px 1px 3px 1px #ccc;
}
.rowDate span {
  margin-right: 8px;
}
.containerSite {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.site {
  font-weight: bold;
  font-size: 28px;
  line-height: 38px;
}

.icon {
  line-height: 38px;
  margin-left: 20px;
  cursor: pointer;
  transition: 0.2s ease;
}
.icon:hover {
  font-size: 1.1rem;
  font-weight: bold;
}
.rowMenu {
  justify-content: flex-start;
  width: 100%;
  line-height: 40px;
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .psReportsDetailUpperBar {
    margin-top: 16px;
    height: 120px;
    margin-right: 0;
    margin-bottom: 0px;
  }
  .psReportsDetailUpperBar > .row {
    padding-left: 0px;
  }
  .avatar {
    display: none;
  }
  .menu {
    display: block;
    align-self: flex-end;
  }
  .rowDate {
    margin-left: 0px;
  }
}
</style>
